(function () {
    'use strict';

    angular
        .module('app')
        .controller('TourPromoController',['$scope', '$rootScope', '$http', '$state', '$stateParams', '$q', '$log', TourPromoController]);

    function TourPromoController($scope, $rootScope, $http, $state, $stateParams, $q, $log) {
        const vm = this;

        vm.$onInit = function () {
            $rootScope.header_inverted = true;
            $rootScope.on_dashboard = false;
            $rootScope.dark_text_header = true;

            getTour();
        }

        async function getTour() {
            const response = await $q.when($http.get('api/users/private/tours/' + $stateParams.tour_id));
            $scope.$applyAsync(() => {
                vm.tour = response.data.tour;
                $log.debug('Tour to promo', vm.tour);
            });
        }
    }
})();
